import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import { Router, NavigationEnd } from '@angular/router';
import {EventsService} from 'angular4-events';
// import {PubSubService} from 'angular2-pubsub';


declare var $: any;
declare var body: any;
declare var Nanobar: any;
declare var toastr: any;
@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit {
  nao = new Nanobar();
  supportData: any;
  msgImg: any;
  disName: any;
  disEmail: any;
  managerName: any;
  subject: any;
  trackId: any;
  description: any;
  filterValue = 'All';
  filterValCount = 2;
  searchSupport = '';
  clearTimeout: any;
  contactSupportSearchData: any;
  contactDataFound = false;
  msgFound = false;
  paginatedDataSupport: any;
  supportPageCount = 0;
  supportLastPage = true;
  constructor(private dataService: DataService, private router: Router) { }
 // supportListFunction() {
 //    this.nao.go(30);
 //    this.dataService.supportList(window.localStorage.getItem('token')).subscribe(
 //      (data) => {
 //        this.nao.go(100);
 //        this.supportData = data;
 //      },
 //      (error) => {
 //        this.nao.go(100);
 //        console.log('error', error);
 //      }
 //    );
 //  }
  readMessageFunction(id) {
    this.dataService.readMessage(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        // this.supportListFunction();
        this.filterSearch();
      },
      (error) => {

      }
    );
  }
  openMsgDetailPop(obj) {
    this.msgImg = obj.dispensary_image;
    this.disName = obj.name ;
    this.disEmail = obj.email;
    this.managerName = obj.manager_name;
    this.subject = obj.subject;
    this.trackId = obj.tracking_id;
    this.description = obj.description;
    $('#readMsgPop').modal('show');
  }
  filterValUpdate(val) {
    this.filterValue = val;
    if (val === 'Today') {
      this.filterValCount = 1;
      this.filterSearch();
    }
    if (val === 'All') {
      this.filterValCount = 2;
      this.filterSearch();
    }
  }
  filterSearch() {
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
    this.supportPageCount = 0;
    this.nao.go(30);
    console.log('login data');
    this.dataService.supportListSearchFilter(window.localStorage.getItem('token'), this.searchSupport, this.filterValCount).subscribe(
      (data) => {
        this.nao.go(100);
        this.supportData = [];
        this.supportData = data;
        this.msgFound = true;
        this.supportLastPage = this.supportData.last_page;
        this.supportPageCount++;
        this.supportData = this.supportData.items;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
    }, 1000);
  }
  clearSearch() {
    this.searchSupport = '';
    this.filterSearch();
  }
  supportListSearchFilterByPageFunction() {
    this.nao.go(30);
    console.log('login data');
    this.dataService.supportListSearchFilterByPage(window.localStorage.getItem('token'), this.searchSupport, this.filterValCount, this.supportPageCount).subscribe(
      (data) => {
        this.nao.go(100);
        this.paginatedDataSupport = data;
        this.supportLastPage = this.paginatedDataSupport.last_page;
        this.supportPageCount++;
        this.paginatedDataSupport = this.paginatedDataSupport.items;
        for (var i = 0; i < this.paginatedDataSupport.length; i++) {
          this.supportData.push(this.paginatedDataSupport[i]);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  ngOnInit() {
    // this.supportListFunction();
    this.filterSearch();
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#support').css('color', '#d77229');
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
  }

}



// WEBPACK FOOTER //
// ./src/app/support/support.component.ts